import { HttpContextToken } from '@angular/common/http';

/**
 * Opt-in flag telling `errorInterceptor` to skip the error toast for a single request.
 *
 * Set it only on requests whose failure the caller handles itself, either by recovering
 * silently (the campaign list's stale-`pageToken` 422, which falls back to the first page,
 * AZTGSA-10906) or by showing its own tailored toast instead of the generic one
 * (`documentValidate`, AZTGSA-12728). The error is still re-thrown; only the interceptor's
 * toast is suppressed.
 */
export const SUPPRESS_HTTP_ERROR_TOAST = new HttpContextToken<boolean>(() => false);

/**
 * Opt-in flag telling `authInterceptor` to skip attaching the app's own Authorization header.
 *
 * Set it only on requests that target a presigned URL (campaign file uploads, direct-to-S3/JADE
 * PUT) — those URLs are already authenticated by their signature and reject an unexpected
 * Authorization header.
 */
export const SKIP_AUTH_HEADER = new HttpContextToken<boolean>(() => false);
